import numeral from "numeral";
import { v4 as uuidv4 } from "uuid";

export const isNumber = (value: any) => {
    if (value != null) {
        if (!Number.isNaN(Number.parseFloat(value))) {
            return true;
        } else {
            return numeral.validate(value.toString(), numeral.locale());
        }
    } else {
        return false;
    }
};

export const bytesToGB = (bytes: number) => {
    const gb = bytes / (1024 * 1024 * 1024);
    return +gb.toFixed(2);
};

export const bytesToMB = (bytes: number) => {
    if (!bytes) return 0;
    const mb = bytes / (1024 * 1024);
    return +mb.toFixed(2);
};

export const generateRandomNumber = () => {
    const uuid = uuidv4();
    const randomHex = uuid.replaceAll("-", "").slice(0, 8);
    return Number.parseInt(randomHex, 16) / 0xffffffff;
};
